export const CONSTELLATIONS = [
  {
    name: 'Orion',
    coords: [
      [83.8, 9.9],
      [84.6, 21.1],
      [81.3, 6.3],
      [79.2, 2.1],
      [76.6, 5.6],
      [77.4, -9.7],
      [78.6, -8.2],
      [83.0, -1.2],
      [84.0, -1.2],
      [83.8, 9.9],
    ],
  },
  {
    name: 'Ursa Major',
    coords: [
      [165.9, 61.8],
      [183.9, 57.0],
      [193.5, 55.9],
      [200.9, 54.9],
      [206.9, 49.3],
      [210.0, 54.1],
      [200.9, 54.9],
    ],
  },
  {
    name: 'Cassiopeia',
    coords: [
      [2.3, 59.1],
      [9.2, 59.0],
      [14.2, 60.7],
      [21.5, 60.2],
      [28.6, 63.7],
    ],
  },
  {
    name: 'Scorpius',
    coords: [
      [247.4, -26.4],
      [252.0, -25.6],
      [253.7, -22.6],
      [255.0, -28.2],
      [258.0, -35.9],
      [259.2, -38.0],
      [260.9, -38.0],
      [263.4, -37.1],
      [264.3, -43.0],
    ],
  },
  {
    name: 'Leo',
    coords: [
      [152.1, 11.9],
      [154.9, 19.8],
      [168.5, 23.8],
      [177.3, 14.6],
      [168.5, 23.8],
      [170.7, 15.9],
    ],
  },
];
